import { Component, EventEmitter, Input, Output } from '@angular/core'
import { AAR_FILTER_TYPES, AAR_SORTING_ORDER, AAR_SORTING_TYPES, AARSorting } from '../../../../location/location.types'
import { CheckboxChangeEventDetail } from '@ionic/angular/standalone'

export type FacilitiesPreferences = {
  openNow: AAR_FILTER_TYPES
  availableNow: boolean
  sortBy: AARSorting
}

@Component({
  selector: 'app-facilities-preferences-modal',
  templateUrl: './facilities-preferences-modal.component.html',
  styleUrls: ['./facilities-preferences-modal.component.scss']
})
export class FacilitiesPreferencesModalComponent {
  @Input() preferences: FacilitiesPreferences
  @Input() hasRatings: boolean
  @Output() apply = new EventEmitter<FacilitiesPreferences>()
  @Output() close = new EventEmitter<void>()

  savingsOffLabel = () => $localize`$75 Off`

  localPreferences: FacilitiesPreferences = {
    openNow: AAR_FILTER_TYPES.ALL,
    availableNow: false,
    sortBy: {
      type: AAR_SORTING_TYPES.DEFAULT,
      order: AAR_SORTING_ORDER.DEFAULT
    }
  }

  ngOnInit() {
    this.localPreferences = { ...this.preferences }
  }

  handleToggleOpenNow = () => {
    this.localPreferences.openNow = this.localPreferences.openNow === AAR_FILTER_TYPES.OPEN ?
      AAR_FILTER_TYPES.ALL :
      AAR_FILTER_TYPES.OPEN
  }

  handleToggleAvailableNow = () => {
    this.localPreferences.availableNow = !this.localPreferences.availableNow
  }

  handleSortByDistance = (event:  CustomEvent<CheckboxChangeEventDetail>) => {
    this.localPreferences.sortBy = {
      type: AAR_SORTING_TYPES.DISTANCE,
      order: event.detail.checked ? AAR_SORTING_ORDER.DESCENDING : AAR_SORTING_ORDER.DEFAULT
    }
  }

  handleSortByRating = (event:  CustomEvent<CheckboxChangeEventDetail>) => {
    this.localPreferences.sortBy = {
      type: AAR_SORTING_TYPES.RATING,
      order: event.detail.checked ? AAR_SORTING_ORDER.ASCENDING : AAR_SORTING_ORDER.DEFAULT
    }
  }

  handleApply = () => {
    this.apply.emit(this.localPreferences)
    this.close.emit()
  }

  handleReset = () => {
    this.localPreferences = {
      openNow: AAR_FILTER_TYPES.ALL,
      availableNow: false,
      sortBy: {
        type: AAR_SORTING_TYPES.DEFAULT,
        order: AAR_SORTING_ORDER.DEFAULT
      }
    }
  }

  handleClose = () => {
    this.close.emit()
  }

  isSortedByDistance() {
    const { type, order } = this.localPreferences.sortBy
    return type === AAR_SORTING_TYPES.DISTANCE && order === AAR_SORTING_ORDER.DESCENDING
  }

  isSortedByRating() {
    const { type, order } = this.localPreferences.sortBy
    return type === AAR_SORTING_TYPES.RATING && order === AAR_SORTING_ORDER.ASCENDING
  }

  protected readonly AAR_FILTER_TYPES = AAR_FILTER_TYPES
  protected readonly AAR_SORTING_TYPES = AAR_SORTING_TYPES
  protected readonly AAR_SORTING_ORDER = AAR_SORTING_ORDER
}
